import { useContext } from "react";
import { useSearchParams } from "react-router-dom";

import { ServiceRequest } from "@medplum/fhirtypes";

import { IconTestPipe } from "@tabler/icons-react";

import EmptyRow from "@/components/EmptyRow";
import { ProfileContext } from "@/contexts/profile";
import { isFilteringLabOrders } from "@/health-gorilla/utils/labs";

import LabOrdersClientRow from "./LabOrdersClientRow";
import LabOrdersRow from "./LabOrdersRow";

interface LabOrdersRowsProps {
  results: ServiceRequest[];
  onView: (labOrder: ServiceRequest) => void;
  onAdd?: () => void;
  showClientColumn?: boolean;
}

export default function LabOrderRows({
  results,
  onAdd,
  onView,
  showClientColumn = false,
}: LabOrdersRowsProps) {
  const { isPatient } = useContext(ProfileContext);
  const [searchParams] = useSearchParams();

  if (results.length === 0) {
    let text = "No Lab orders.";
    if (isFilteringLabOrders(searchParams)) {
      text = "No Lab orders found.";
    }

    return (
      <EmptyRow
        text={text}
        Icon={IconTestPipe}
        addButtonLabel="Order a Lab"
        onAdd={!isPatient ? onAdd : undefined}
      />
    );
  }

  return results.map((result) =>
    isPatient ? (
      <LabOrdersClientRow key={result.id} result={result} onView={onView} />
    ) : (
      <LabOrdersRow
        key={result.id}
        result={result}
        onView={onView}
        showClientColumn={showClientColumn}
      />
    ),
  );
}
